import { createSelector } from "reselect";

import {
  getAssignmentSectionIds,
  getNumberOfSectionsCompleted
} from "seneca-common/features/assignments/features/student-assignments/state";
import { makeGetCourseLeafSectionIds } from "seneca-common/features/course/state";

export default function makeGetAssignmentProgress(
  assignmentId: string,
  courseId: string
): (arg0: any) => number {
  const getNumberOfExistingAssignmentSectionIds =
    makeGetNumberOfExistingAssignmentSections(assignmentId, courseId);

  return createSelector(
    s => getNumberOfSectionsCompleted(s, assignmentId),
    getNumberOfExistingAssignmentSectionIds,
    (completed, total) => (completed / total) * 100
  );
}

function makeGetNumberOfExistingAssignmentSections(
  assignmentId: string,
  courseId: string
): (arg0: any) => number {
  const getCourseLeafSectionIds = makeGetCourseLeafSectionIds(courseId);
  return createSelector(
    getCourseLeafSectionIds,
    s => getAssignmentSectionIds(s, assignmentId),
    (courseSectionIds, assignmentSectionIds) => {
      return assignmentSectionIds.filter((sectionId: string) =>
        courseSectionIds.includes(sectionId)
      ).size;
    }
  );
}
